<app-loader />
<router-outlet></router-outlet>
